/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogcharts_Nodata2Inputs */

const id_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada data yang tersedia untuk ditampilkan.`)
};

const ms_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada data tersedia untuk dipaparkan.`)
};

const da_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen data tilgængelige til visning.`)
};

const de_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Daten zum Anzeigen verfügbar.`)
};

const en_us2_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available to display.`)
};

const es_es2_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay datos disponibles para mostrar.`)
};

const es_mx2_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay datos disponibles para mostrar.`)
};

const fil_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang available na data upang ipakita.`)
};

const fr_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée disponible à afficher.`)
};

const it_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato disponibile da visualizzare.`)
};

const hu_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs megjeleníthető adat.`)
};

const nl_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen gegevens beschikbaar om weer te geven.`)
};

const no_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen data tilgjengelig for visning.`)
};

const pl_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych do wyświetlenia.`)
};

const pt_br2_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available to display.`)
};

const pt_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dados disponíveis para mostrar.`)
};

const ro_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu sunt date disponibile de afișat.`)
};

const fi_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei saatavilla olevia tietoja näytettäväksi.`)
};

const sv_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen data tillgänglig att visa.`)
};

const vi_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu để hiển thị.`)
};

const tr_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görüntülenecek veri yok.`)
};

const cs_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejsou k dispozici žádná data k zobrazení.`)
};

const bg_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма налични данни за показване.`)
};

const ru_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет данных для отображения.`)
};

const uk_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає даних для відображення.`)
};

const ar_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد بيانات متاحة للعرض.`)
};

const hi_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई डेटा उपलब्ध नहीं।`)
};

const th_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีข้อมูลให้แสดง`)
};

const ja_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示できるデータがありません。`)
};

const zh_cn2_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available to display.`)
};

const zh_hant1_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available to display.`)
};

const ko_components_changelogcharts_nodata2 = /** @type {(inputs: Components_Changelogcharts_Nodata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available to display.`)
};

/**
* | output |
* | --- |
* | "No data available to display." |
*
* @param {Components_Changelogcharts_Nodata2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogcharts_nodata2 = /** @type {((inputs?: Components_Changelogcharts_Nodata2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogcharts_Nodata2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogcharts_nodata2(inputs)
	if (locale === "ms") return ms_components_changelogcharts_nodata2(inputs)
	if (locale === "da") return da_components_changelogcharts_nodata2(inputs)
	if (locale === "de") return de_components_changelogcharts_nodata2(inputs)
	if (locale === "en-US") return en_us2_components_changelogcharts_nodata2(inputs)
	if (locale === "es-ES") return es_es2_components_changelogcharts_nodata2(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogcharts_nodata2(inputs)
	if (locale === "fil") return fil_components_changelogcharts_nodata2(inputs)
	if (locale === "fr") return fr_components_changelogcharts_nodata2(inputs)
	if (locale === "it") return it_components_changelogcharts_nodata2(inputs)
	if (locale === "hu") return hu_components_changelogcharts_nodata2(inputs)
	if (locale === "nl") return nl_components_changelogcharts_nodata2(inputs)
	if (locale === "no") return no_components_changelogcharts_nodata2(inputs)
	if (locale === "pl") return pl_components_changelogcharts_nodata2(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogcharts_nodata2(inputs)
	if (locale === "pt") return pt_components_changelogcharts_nodata2(inputs)
	if (locale === "ro") return ro_components_changelogcharts_nodata2(inputs)
	if (locale === "fi") return fi_components_changelogcharts_nodata2(inputs)
	if (locale === "sv") return sv_components_changelogcharts_nodata2(inputs)
	if (locale === "vi") return vi_components_changelogcharts_nodata2(inputs)
	if (locale === "tr") return tr_components_changelogcharts_nodata2(inputs)
	if (locale === "cs") return cs_components_changelogcharts_nodata2(inputs)
	if (locale === "bg") return bg_components_changelogcharts_nodata2(inputs)
	if (locale === "ru") return ru_components_changelogcharts_nodata2(inputs)
	if (locale === "uk") return uk_components_changelogcharts_nodata2(inputs)
	if (locale === "ar") return ar_components_changelogcharts_nodata2(inputs)
	if (locale === "hi") return hi_components_changelogcharts_nodata2(inputs)
	if (locale === "th") return th_components_changelogcharts_nodata2(inputs)
	if (locale === "ja") return ja_components_changelogcharts_nodata2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogcharts_nodata2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogcharts_nodata2(inputs)
	return ko_components_changelogcharts_nodata2(inputs)
});
export { components_changelogcharts_nodata2 as "components.changelogCharts.noData" }